import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {ApplicationsConfig} from "../../../shared/interface/applications-config";
import {FormBuilder, FormGroup} from "@angular/forms";
import {PermissionsService} from "../../../shared/services/permissions.service";
import {PermissionsConfig} from "../../../shared/interface/permissions-config";

@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  applicationsConfig: ApplicationsConfig;

  @Input() applicationsForm?: FormGroup;
  @Input() currentApplications: any;
  @Input() disabled = false;

  constructor(
    private permissionsService: PermissionsService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    if (!this.applicationsForm) {
      this.applicationsForm = this.fb.group({});
    }

    this.permissionsService.getApplicationsConfig()
      .subscribe((applicationsConfig: ApplicationsConfig) => {

        applicationsConfig.applications.forEach((application) => {
          this.applicationsForm.addControl(
            application.module,
            this.fb.control(this.currentApplications[application.module] ?? 'none')
          );
        });

        this.applicationsConfig = applicationsConfig;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
